import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/features/auth/utils/permissionGuard';
import { FIELD_OPS_PERMISSIONS } from '@/constants/permissions';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { SurveyCreatePage } from '@/features/surveys/pages/SurveyCreatePage';

export const Route = createFileRoute('/_auth/feedback/surveys/new')({
  beforeLoad: () => requirePermission(FIELD_OPS_PERMISSIONS.SURVEY_CREATE),
  component: () => (
    <ErrorBoundary moduleName="Create Survey">
      <Suspense fallback={<PageLoader />}>
        <SurveyCreatePage />
      </Suspense>
    </ErrorBoundary>
  ),
});
